import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { observeProperty } from '@lcms/shared/data-access-user';
import { Observable, from, groupBy, map, mergeMap, reduce, tap, toArray } from 'rxjs';

@Component({
  selector: 'lcms-ressources-result',
  templateUrl: './ressources-result.component.html',
  styleUrls: ['./ressources-result.component.scss'],
})
export class RessourcesResultComponent {
  sanitizer=inject(DomSanitizer);
  @Input() cmpData:any;
  @Input() showDetails?:boolean;

  showData:any;
  data$:Observable<any> = observeProperty(this as RessourcesResultComponent,'cmpData').pipe(
    map((res)=>{
      //  return res.filter((res:any)=>res?.highlight).map((ressource:any)=>{
       return res.map((ressource:any)=>{
        const metadata = ressource._source.metadata;
        let highlighter:any;
        if(metadata?._type=='ressource'){
           ( (ressource?.highlight?.content ? (ressource.highlight?.content[0] ?? '') : '') || '').split('##')
                .filter((ct: string) => ct.includes('<em>'))
                .forEach((ct:any)=>{
                  const item= ct.split(':').map((str:string) => str.trim());
                  highlighter={...highlighter,...({[item[0]?.replace('_','')]:item[1]})}
                  // return {[item[0]?.replace('_','')]:item[1]}
                })
                
            }
            else if(metadata?._type=='screen'){
              const content = ressource?.highlight?.content ? (ressource.highlight.content[0] ?? []) : [];
              highlighter={
                content: content
              }
            }
    
        return {
          ...metadata,
            highlights: highlighter,
        };
        }) 
    }),
    tap((res)=>(console.log('resources ',res  )))
  )

  getKeys(obj:any){
    return obj ? Object.keys(obj) : []
  }
  sanitize(term:string){
    return this.sanitizer.bypassSecurityTrustHtml(term);
  }
}
